<template>
  <div style="width: 100%">
    <apexchart :id="downloadId" style="width: 100%" :width="width" :height="height" type="bubble" @dataPointSelection="dataPointSelectionHandler" :options="chartOptions" :series="chartSeries"></apexchart>
    <div class="custom-legend-bubble">Bubble Size = Number of {{ choosenTab }}</div>
  </div>
</template>
<script>
export default {
  props: {
    series: { type: Array, default: () => [] },
    options: { type: Object, default: null },
    height: { type: String, default: "250px" },
    downloadId: { type: String, default: "default" },
    choosenTab: { type: String, default: "Activities" }
  },
  data() {
    return {
      chartSeries: this.series,
      chartOptions: this.options,
      width: "100%"
    };
  },
  watch: {
    series() {
      this.chartSeries = this.series;
    },
    height() {
      setTimeout(() => {
        window.dispatchEvent(new Event("resize"));
      }, 1);
    },
    options() {
      this.chartOptions = this.options;
    }
  },
  methods: {
    dataPointSelectionHandler(e, chartContext, config) {
      this.$emit("onDataPointClick", { chartContext, config });
    }
  }
};
</script>
<style lang="scss" scoped>
.custom-legend-bubble {
  &::before {
    background-color: var(--study-primary-color);
    background-size: 15px;
    content: "";
    width: 15px;
    height: 15px;
    position: absolute;
    left: -20px;
    border-radius: 10px;
  }
  color: #666669;
  font-size: 10px;
  position: absolute;
  left: calc(50% - 55px);
  bottom: 13px;
}
</style>
